export const EXPERIMENT_CAL_REQUESTED = 'EXPERIMENT_CAL_REQUESTED';
export const EXPERIMENT_CAL_SUCCESS = 'EXPERIMENT_CAL_SUCCESS';
export const EXPERIMENT_CAL_FAILED = 'EXPERIMENT_CAL_FAILED';
